import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '@/views/AITools/store/index'
// enum
import { AIToolNameEnum, AIToolSourceEnum, AIGenerateStatusEnum } from '@/constants/AI-tool'

@Component({
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 来源
    source: {
      type: String
    },
    // 生成状态 ( Pending: 等待生成状态; Generating: 正在生成状态; Finish: 生成完成; )
    status: {
      type: String,
      default: AIGenerateStatusEnum.PENDING
    },
    // 生成结果
    result: {
      type: String,
      default: ''
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class AIToolResult extends Vue {

  mounted() {

  }

  /****************************** 历史生成数据 ******************************/

  /** 跳转到登录页 */
  toLoginPage() {
    this.$redirectTo({
      url: `/pages/login/login?from=AIImage&timestamp=${ new Date().getTime() }`
    })
  }

  toHistoryPage() {
    const ww_token = localStorage.getItem('ww_token')
    if (!ww_token) {
      this.toLoginPage()
      return
    }
    switch(this.$props.source) {
      // 黄金开场
      case AIToolSourceEnum.GOLD_START:
        this.$navigateTo({
          url: `/package-tools/pages/ai-history/ai-history?type=${ 'CITATION' }`
        })
        break;
      // 智能标题
      case AIToolSourceEnum.TITLE:
        this.$navigateTo({
          url: `/package-tools/pages/ai-history/ai-history?type=${ 'TITLE' }`
        })
        break;
      // 智能描述
      case AIToolSourceEnum.DESCRIPTION:
        this.$navigateTo({
          url: `/package-tools/pages/ai-history/ai-history?type=${ 'DESC' }`
        })
        break;
      // 智能改写
      case AIToolSourceEnum.REWRITE:
        this.$navigateTo({
          url: `/package-tools/pages/ai-history/ai-history?type=${ 'REWRITE' }`
        })
        break;
    }
  }

}
